// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TtC5w","newExpiryDate":"styles_newExpiryDate__rapzd","footer":"styles_footer__25woZ"};